// extracted by mini-css-extract-plugin
module.exports = {"divider":"textDivider_divider__1YL1F","line":"textDivider_line__2EKYx","text":"textDivider_text__19-Fk"};